import { createFileRoute, useSearch } from "@tanstack/react-router";
import { PortalVerificationForm } from "@/components/portal/PortalVerificationForm";

type VerifySearchParams = {
  reference?: string;
  /** Threaded through from PortalSignInForm so the post-MFA navigation
   * still lands on the original deep-link (e.g. an Excel Add-in handoff
   * URL with jobId/orgId/reason). Validated in the verify form before
   * navigate(), not here, so the route stays a thin search-parser. */
  redirect?: string;
};

export const Route = createFileRoute("/portal_/sign-in_/verify")({
  component: PortalVerifyPage,
  validateSearch: (search: Record<string, unknown>): VerifySearchParams => ({
    reference:
      typeof search.reference === "string" ? search.reference : undefined,
    redirect:
      typeof search.redirect === "string" ? search.redirect : undefined,
  }),
});

function PortalVerifyPage() {
  const { reference, redirect } = useSearch({
    from: "/portal_/sign-in_/verify",
  });
  return (
    <PortalVerificationForm
      reference={reference ?? null}
      redirect={redirect ?? null}
    />
  );
}
